import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import './Auth.css';

const AdminLogin = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const { login, logout, user } = useAuth();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (user) {
      if (user.role === 'admin' || user.role === 'sub-admin') {
        navigate('/admin');
      } else {
        setError('Access denied. Admin credentials required.');
      }
    }
  }, [user, navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      // Check if user is admin or sub-admin
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData && (userData.role === 'admin' || userData.role === 'sub-admin')) {
        navigate('/admin');
      } else {
        logout();
        setError(t('auth.adminsOnly'));
      }
    } else {
      setError(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page admin-auth">
      <div className="auth-container">
        <div className="auth-header">
          <div className="role-icon admin-icon">🛡️</div>
          <h1>{t('auth.adminPortal')}</h1>
          <p>{t('auth.adminSubtitle')}</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{t('auth.email')}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="admin@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label>{t('auth.password')}</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
            />
            <Link to="/forgot-password" className="forgot-password-link">
              {t('auth.forgotPassword')}
            </Link>
          </div>

          {error && <div className="error">{error}</div>}

          <button type="submit" className="btn-primary btn-admin" disabled={loading}>
            {loading ? t('auth.signingIn') : t('auth.loginBtn')}
          </button>

          <div className="auth-links">
            <Link to="/login" className="back-link">{t('auth.studentLogin')}</Link>
            <Link to="/instructor/login" className="back-link">{t('auth.instructorLogin')}</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
